<template>
  <v-dialog v-model="dialog" :persistent="persistent" max-width="300px" style="margin: auto 4px">
    <v-card>
      <v-card-title>
        <span class="headline">Login</span>
      </v-card-title>
      <v-card-text>
        <v-form v-if="dialog" ref="form" v-model="formValid" @submit.prevent="next">
          <v-text-field v-model.trim="username"
                        :loading="loading && step === 1"
                        :rules="usernameRules"
                        label="Username or Provider ID"
                        :disabled="step === 2"
                        autofocus />
          <v-text-field v-if="step === 2"
                        ref="pwd"
                        v-model.trim="password"
                        :type="hidePassword ? 'password' : 'text'"
                        :loading="loading"
                        :rules="passwordRules"
                        :append-icon="hidePassword ? 'visibility' : 'visibility_off'"
                        label="Password"
                        @click:append="hidePassword = !hidePassword"
                        @keyup.enter="doLogin" />
          <div class="mt-3">
            <tooltip bottom>
              <a slot="activator" :href="forgotPasswordLink">Login Assistance</a>
              Login Assistance
            </tooltip>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn v-if="step === 1 && persistent != null && persistent !== false" flat @click="dialog = false">
          Cancel
        </v-btn>
        <v-btn v-if="step === 1" :loading="loading" color="primary" @click="next()">
          Next
        </v-btn>
        <v-btn v-if="step === 2 && !loading" flat @click="dialog = false">
          Cancel
        </v-btn>
        <v-btn v-if="step === 2" :loading="loading" color="primary" @click="doLogin()">
          Login
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { rules } from '$app/validations'

  const defaults = () => ({
    loading: false,
    formValid: false,
    invalidUser: false,
    invalidPassword: false,
    step: 1,
    username: '',
    password: '',
    hidePassword: true
  });

  export default {
    props: ['value', 'persistent'],
    data: () => ({
      ...defaults()
    }),
    computed: {
      loginLink() {
        return `${this.$configs.oldSite}/Login.aspx`;
      },
      registrationLink() {
        return `${this.$configs.oldSite}/Registration.aspx`;
      },
      forgotPasswordLink() {
        return `${this.$configs.oldSite}/ForgotPassword.aspx`;
      },
      usernameRules() {
        return [...rules.required, () => !this.invalidUser || 'User Not Found'];
      },
      passwordRules() {
        return [...rules.required, () => !this.invalidPassword || 'Wrong Username or Password'];
      },
      dialog: {
        get() {
          return this.value;
        },
        set(val) {
          if (!val) {
            this.reset();
          }
          this.$emit('input', val);
        }
      }
    },
    watch: {
      username() {
        this.invalidUser = false;
      },
      password() {
        this.invalidPassword = false;
      }
    },
    methods: {
      next() {
        if (this.step === 1) {
          this.checkUser();
        } else if (this.step === 2) {
          this.doLogin();
        }
      },
      checkUser() {
        if (this.$refs.form.validate()) {
          this.loading = true;
          this.$http.post('account/PreLoginCheck', { username: this.username })
            .then(resp => {
              if (resp && resp.data && resp.data.success) {
                if (resp.data.site === 'new') {
                  this.step = 2;
                  this.$nextTick(() => this.$refs.pwd.focus())
                } else if (resp.data.site === 'registration') {
                  window.location = `${this.registrationLink}?tkn=${resp.data.tkn}`;
                } else {
                  window.location = `${this.loginLink}?tkn=${resp.data.tkn}`;
                }
              } else {
                this.invalidUser = true;
                this.$refs.form.validate();
              }
            })
            .finally(() => { this.loading = false; });
        }
      },
      doLogin() {
        if (this.$refs.form.validate()) {
          this.loading = true;
          this.$http.post('account/Login', { username: this.username, password: btoa(this.password) })
            .then(resp => {
              if (resp && resp.data && resp.data.user) {
                this.$store.dispatch('user/setUser', resp.data.user);
                this.dialog = false;
                this.reset();
              } else {
                this.invalidPassword = true;
                this.$refs.form.validate();
              }
            })
            .catch(err => {
              if (err && err.response && err.response.status === 401) {
                this.invalidPassword = true;
                this.$refs.form.validate();
              } else {
                this.dialog = false;
                this.$snackbar('Error Logging In');
              }
            })
            .finally(() => { this.loading = false; });
        } else {
          this.$refs.pwd.focus();
        }
      },
      reset() {
        Object.assign(this, defaults());
        this.$refs.form.reset();
      }
    }
  }
</script>
